import { Component, OnInit, Inject, AfterViewInit , ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SelectedCardEvent } from '@services/message-bus/message-bus-events';
import { Card } from '@models/post-login.model';
import { MessageBusService } from '@services/message-bus/message-bus.service';
import { ThemeService } from '@services/theme.service';
import { DashboardService } from '../../pages/dashboard/dashboard.service';
import { AnalyticsService } from '@services/analytics.service';
import { Router } from '@angular/router';
import { PrivacyPolicyComponent } from '@common/privacy-policy/privacy-policy.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'smione-warnings',
  templateUrl: './warnings.component.html',
  styleUrls: ['./warnings.component.scss']
})
export class WarningsComponent implements OnInit , AfterViewInit {
  public selectedCard: Card = {} as Card;
  count :number = 0;
  componentName : string = 'Warnings';



   // Map of custom href keys to internal routes
  private hrefRouteMap: { [key: string]: { pathName: string; route: string } } = {
    'DDA': { pathName: 'directdeposit', route: '/smione/manage' },
    'CARD_SERVICES': { pathName: 'cardservices', route: '/smione/manage'}
  };


  constructor(
    public dialogRef: MatDialogRef<WarningsComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dashboardService: DashboardService,
    public messageBus: MessageBusService,
    private themeService: ThemeService,
    private analyticsService: AnalyticsService,
    private router: Router,
    private elementRef: ElementRef,
   public dialog: MatDialog
  ) { 
    this.messageBus.on(SelectedCardEvent, (event) => { this.selectedCard = event.payload });
    this.onloadmakeAlertRead(this.dialogData[this.count], false);
  }

  ngOnInit() {
    this.themeService.SetThemeInitially();
    console.log(this.dialogData);
  }

   ngAfterViewInit() {

    this.dialogRef.afterOpened().subscribe(() => {
      const dialogContainer = this.elementRef.nativeElement.closest('.mat-dialog-container');
      if (dialogContainer) {
        dialogContainer.setAttribute('aria-label', 'Warnings dialog');
      }
    });
   

    setTimeout(() => {
      const dialogContainer = this.elementRef.nativeElement.closest('.mat-dialog-container');
      if (dialogContainer && !dialogContainer.getAttribute('aria-label')) {
        dialogContainer.setAttribute('aria-label', 'Warnings dialog');
      }
    }, 0);
  }




  isValidUrl(str: string): boolean {
    try {
      const url = new URL(str);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
      return false;
    }
  }


    onContentClick(event: Event, i:any): void {
    const target = event.target as HTMLElement;

    const anchor = target.closest('a') as HTMLAnchorElement;

    if (anchor && anchor.hasAttribute('href')) {
      const href = anchor.getAttribute('href');

      if (href) {
        event.preventDefault();
        event.stopPropagation();

        if (this.isValidUrl(href)) {
           this.close()
          if (href.toLowerCase().includes('smionecard.com')) {
            window.open(href, '_blank');
          } else {
            this.openModal(href);
          }
        } else {
          const routeConfig = this.hrefRouteMap[href.toUpperCase()];
          if (routeConfig) {
            localStorage.setItem('pathName', routeConfig.pathName);
            this.makeAlertRead(i)
            this.router.navigateByUrl(routeConfig.route);
          } else {
            this.makeAlertRead(i)
            this.router.navigateByUrl(href);
          }
        }
      }
    }
  }

  openModal(RedirectUrl) {
    const dialogRef = this.dialog.open(PrivacyPolicyComponent, {
      disableClose: true,
      data: { RedirectUrl: RedirectUrl }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        window.open(RedirectUrl, "_blanck");
      }
    });
  }
  

  showNext(): void {
     if (this.count < this.dialogData.length - 1) {
         this.makeAlertRead(this.dialogData[this.count]);
    }
}

onloadmakeAlertRead(alert , canCallApi){
  this.analyticsService.gtag(this.componentName, `makeAlertRead`);
  this.selectedCard.WarningShown = true;
  if(canCallApi)
  this.dashboardService.makeAlertsRead(this.selectedCard.CardKey, { cardKey: this.selectedCard.CardKey, AlertIds: [alert['ID']] }).subscribe(
    (res)=>{
      if(res['Response']['Success']){
        // if((this.count+1) == this.dialogData.length){ this.close(true); }
        // this.count++;
      }
    }
  );
}
 

  makeAlertRead(alert){
    this.analyticsService.gtag(this.componentName, `makeAlertRead`);
    this.selectedCard.WarningShown = true;
    this.dashboardService.makeAlertsRead(this.selectedCard.CardKey, { cardKey: this.selectedCard.CardKey, AlertIds: [alert['ID']] }).subscribe(
      (res)=>{
        if(res['Response']['Success']){
          if((this.count+1) == this.dialogData.length){ this.close(true); }
          this.count++;
        }
      }
    );
  }

  close(flag?){
    this.analyticsService.gtag(this.componentName, `close`);
    this.selectedCard.WarningShown = true;
     this.onloadmakeAlertRead(this.dialogData[this.count], true);
    this.dialogRef.close(flag);  
   } 
}
